import React from "react";

import {
  IFunctionElementUnion,
  FunctionElementState,
  FunctionTypes,
  ISectionElement,
} from "@graffer-inc/form-schema";
import { CorporateSearchElementEditor } from "./corporate-search-element-editor";

type Props = {
  element: IFunctionElementUnion;
  sections: ISectionElement[];
};

// basic structure originates to: https://github.com/graffer-inc/graffer-schemas/blob/357c465ece3543c5920c96d561b7f1ab68486e7e/libs/packages/form-builder/lib/elements/editor-pane/element-editor/function-element-editor/function-element-editor.tsx
export const FunctionElementEditor: React.FC<Props> = ({
  element,
  sections,
}) => {
  return (
    <>
      {new FunctionElementState(element.functionType).matchType({
        [FunctionTypes.CorporateSearch]: (
          <CorporateSearchElementEditor element={element} sections={sections} />
        ),
      })}
    </>
  );
};
